document.addEventListener('DOMContentLoaded', () => {
  const sidebar = document.getElementById('filter-sidebar');
  const overlay = document.getElementById('filter-overlay');
  const openBtn = document.getElementById('open-filters');
  const closeBtn = document.getElementById('close-filters');
  const clearBtn = document.getElementById('clear-filters');
  const applyBtn = document.getElementById('apply-filters');
  const searchInput = document.getElementById('store-search');
  const cards = document.querySelectorAll('.boutique-card');
  const cityBtns = document.querySelectorAll('.js-city-filter');

  const typeCheckboxes = document.querySelectorAll('.js-filter-type');
  const collCheckboxes = document.querySelectorAll('.js-filter-collection');

  // Accordions
  document.querySelectorAll('.js-accordion-trigger').forEach((btn) => {
    btn.addEventListener('click', () => {
      const content = btn.nextElementSibling;
      const icon = btn.querySelector('.js-icon');

      const isExpanded = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', !isExpanded);
      if (content) content.setAttribute('aria-hidden', isExpanded);
      if (icon) icon.classList.toggle('rotate-180');
    });
  });

  // Open/Close sidebar
  function openFilters() {
    sidebar.classList.remove('translate-x-full');
    overlay.classList.remove('hidden');
    // small delay for transition
    setTimeout(() => {
      overlay.classList.remove('opacity-0');
    }, 10);
  }

  function closeFilters() {
    sidebar.classList.add('translate-x-full');
    overlay.classList.add('opacity-0');
    setTimeout(() => {
      overlay.classList.add('hidden');
    }, 300);
  }

  openBtn.addEventListener('click', openFilters);
  closeBtn.addEventListener('click', closeFilters);
  overlay.addEventListener('click', closeFilters);

  // Filter Logic
  let activeCity = '';

  cityBtns.forEach((btn) => {
    btn.addEventListener('click', () => {
      searchInput.value = '';
      const textSpan = btn.querySelector('span');
      if (activeCity === btn.dataset.city) {
        activeCity = '';
        if (textSpan) textSpan.classList.remove('underline');
      } else {
        activeCity = btn.dataset.city;
        cityBtns.forEach((b) => {
          const s = b.querySelector('span');
          if (s) s.classList.remove('underline');
        });
        if (textSpan) textSpan.classList.add('underline');
      }
      applyFiltering();
    });
  });

  searchInput.addEventListener('input', () => {
    applyFiltering();
  });

  clearBtn.addEventListener('click', () => {
    typeCheckboxes.forEach((cb) => {
      cb.checked = false;
    });
    collCheckboxes.forEach((cb) => {
      cb.checked = false;
    });
  });

  applyBtn.addEventListener('click', () => {
    applyFiltering();
    closeFilters();
  });

  function applyFiltering(isInitialLoad = false) {
    const list = document.getElementById('boutiques-list');

    if (!isInitialLoad) {
      list.classList.remove('transition-opacity', 'duration-500');
      list.classList.add('opacity-0');
      // Force reflow per applicare istantaneamente l'opacità 0
      void list.offsetWidth;
    }

    const searchTerm = searchInput.value.toLowerCase().trim();
    const selectedTypes = Array.from(typeCheckboxes)
      .filter((cb) => cb.checked)
      .map((cb) => cb.value.toLowerCase());
    const selectedColls = Array.from(collCheckboxes)
      .filter((cb) => cb.checked)
      .map((cb) => cb.value.toLowerCase());

    cards.forEach((card) => {
      const city = card.dataset.city.toLowerCase();
      const type = card.dataset.type.toLowerCase();
      const colls = card.dataset.collections.toLowerCase();
      const country = card.dataset.country.toLowerCase();
      const postcode = card.dataset.postcode.toLowerCase();
      const address = card.dataset.address.toLowerCase();
      const name = card.dataset.name.toLowerCase();
      const highlighted = card.dataset.highlighted === 'true';

      let matchSearch = true;
      if (searchTerm) {
        matchSearch =
          city.includes(searchTerm) ||
          country.includes(searchTerm) ||
          postcode.includes(searchTerm) ||
          address.includes(searchTerm) ||
          name.includes(searchTerm);
      }

      let matchCityBtn = true;
      if (activeCity) {
        matchCityBtn = city === activeCity.toLowerCase();
      }

      let matchType = true;
      if (selectedTypes.length > 0) {
        matchType = selectedTypes.includes(type);
      }

      let matchColl = true;
      if (selectedColls.length > 0) {
        matchColl = selectedColls.some((c) => colls.includes(c));
      }

      let matchHighlighted = true;
      if (!searchTerm && !activeCity) {
        matchHighlighted = highlighted;
      }

      if (matchSearch && matchCityBtn && matchType && matchColl && matchHighlighted) {
        card.classList.remove('hidden');
        card.classList.add('flex');
      } else {
        card.classList.add('hidden');
        card.classList.remove('flex');
      }
    });

    if (!isInitialLoad) {
      // Ripristina la transizione e rimuovi opacity-0 per lanciare il fade-in
      list.classList.add('transition-opacity', 'duration-500');
      list.classList.remove('opacity-0');
    }
  }

  applyFiltering(true);

  // Mostra la lista con un fade-in dolce dopo che i filtri iniziali (es. highlighted) sono stati applicati
  setTimeout(() => {
    document.getElementById('boutiques-list').classList.remove('opacity-0');
  }, 50);
});
